<template>
  <div class="content">
    <!-- 上白板step -->
    <div class="nav-border">
      <span class="nav-lspan">当前订单状态：<span style="color: green;">{{ this.resDate.orderStatus | DictionaryFilter("ORDER_STATUS") }}</span></span>
      <!-- 按钮 -->
      <div class="nav_but">
        <a-button class="bottom-button" type="primary" ghost @click="cancle">返回</a-button>
      </div>
    </div>

    <!-- body -->
    <div class="body">
      <div class="body-content public_scrill">
        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">基本信息</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid.field"
          :data-source="relevanceBatch_grid.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            1
          </span>
          <!-- 支付方式 -->
          <span slot="payType" slot-scope="text, record, index">
            微信直连
          </span>
          <!-- 订单来源 -->
          <span slot="orderSource" slot-scope="text, record, index">
            小程序订单
          </span>
        </a-table>

        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">商品信息</div>
        </div>

        <!-- 表格2 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_gridTwo.field"
          :data-source="relevanceBatch_gridTwo.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_gridTwo.height,x:relevanceBatch_gridTwo.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index" :key="index">
            {{index+1}}
          </span>
          <template slot="footer" style="display: flex;">
            <div style="flex: 6;">
            </div>
            <span style="flex: 1;text-align: center;">合计：{{total}}</span>
          </template>
        </a-table>

        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">费用信息</div>
        </div>

        <!-- 表格3 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_gridThree.field"
          :data-source="relevanceBatch_gridThree.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_gridThree.height,x:relevanceBatch_gridThree.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{1}}
          </span>
        </a-table>
        
      </div>
    </div>
  </div>
</template>
    
<script>
import {
  queryOrderDetail
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  props: {
    Title: {
      type: String,
      default: () => "Title",
    },
  },
  data() {
    return {
      relevanceBatch_grid: {
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 40,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "订单编号",
            align: "center",
            width: 110,
            dataIndex: "orderNo",
            ellipsis: true,
          },
          {
            title: "客户编号",
            align: "center",
            width: 110,
            dataIndex: "custNo",
            ellipsis: true,
          },
          {
            title: "绑定手机号",
            align: "center",
            width: 110,
            dataIndex: "phone",
            ellipsis: true,
          },
          {
            title: "支付方式",
            colSpan: 1,
            width: 110,
            dataIndex: "payType",
            align: "center",
            ellipsis: true,
            scopedSlots: {
              customRender: "payType",
            },
          },
          {
            title: "订单来源",
            colSpan: 1,
            align: "center",
            width: 110,
            ellipsis: true,
            dataIndex: "orderSource",
            scopedSlots: {
              customRender: "orderSource",
            },
          },
          // {
          //   title: "备注",
          //   colSpan: 1,
          //   align: "center",
          //   width: 300,
          //   ellipsis: true,
          //   dataIndex: "orderRemark",
          // },
        ]
      },

      relevanceBatch_gridTwo: {
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 35,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "商品名称",
            align: "center",
            width: 170,
            dataIndex: "prName",
            ellipsis: true,
          },
          {
            title: "价格",
            align: "center",
            width: 60,
            dataIndex: "prPrice",
            ellipsis: true,
          },
          {
            title: "数量",
            colSpan: 1,
            align: "center",
            width: 60,
            ellipsis: true,
            dataIndex: "prCount",
          },
          {
            title: "商品说明",
            colSpan: 1,
            width: 325,
            dataIndex: "remark",
            align: "center",
            ellipsis: true,
          },
          {
            title: "小计",
            colSpan: 1,
            align: "center",
            width: 130,
            ellipsis: true,
            dataIndex: "goodTotalPrice",
          },
        ]
      },

      relevanceBatch_gridThree: {
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 29,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "商品合计",
            align: "center",
            width: 150,
            dataIndex: "goodTotalAmount",
            ellipsis: true,
          },
          {
            title: "抵扣金额",
            align: "center",
            width: 150,
            dataIndex: "deductionAmount",
            ellipsis: true,
          },
          {
            title: "订单总金额",
            align: "center",
            width: 150,
            dataIndex: "orderTotalAmount",
            ellipsis: true,
          },
          {
            title: "应付款金额",
            colSpan: 1,
            width: 150,
            dataIndex: "shouldPayAmount",
            align: "center",
            ellipsis: true,
          },
        ]
      },

      //响应内容
      resDate:[],
      //审核
      modalTitle: "",
    };
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["ORDER_STATUS"]).then((res) => {
      //查询
      this.queryList();
    }); 
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });

    this.relevanceBatch_gridTwo.width = 0;
    this.relevanceBatch_gridTwo.field.map(item => {
      this.relevanceBatch_gridTwo.width += item.width;
    });

    this.relevanceBatch_gridThree.width = 0;
    this.relevanceBatch_gridThree.field.map(item => {
      this.relevanceBatch_gridThree.width += item.width;
    });
  },
  computed: {
    total() {
      var sum = 0;
      this.relevanceBatch_gridTwo.row.forEach(item => {
        sum += Number(item.goodTotalPrice);
      });
      return sum.toFixed(2);
    }
  },
  methods: {
    //查询接口
    queryList() {
      queryOrderDetail({
        orderNo:this.$route.query.orderNo,
      }).then(res => {
        this.resDate = res.content;
        let obj = [];
        obj.push(res.content)
        this.relevanceBatch_grid.row = obj;
        this.relevanceBatch_gridThree.row = obj;
        this.relevanceBatch_gridTwo.row = obj[0].productBaseMsgList;
      });
    },
    // 取消按钮
    cancle() {
      if (this.$route.query.pages == '工作台') {
        this.$router.push({path:'/home/home-page/home-page',query:{key:'3'}})
      } else if (this.$route.query.pages == '工作台全部') {
        this.$router.push({path:'/home/home-page/home-page',query:{key:'1'}})
      }else {
        this.$router.go(-1); 
      }
    },
  },
};
</script>
    
<style lang="less" scoped>
.content {
  height: 90%;

  .nav-border {
    width: 100%;
    height: 60px;
    background: #fff;
    z-index: 100;
    display: flex;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 2px;
    .nav-lspan {
      margin-left: 100px;
      font-size: 16px;
      float: left;
      margin: 8px 8px 8px 30px;
      color: black;
      flex: 1;
    }
    .nav_but{
      margin-right: 30px;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    height: 88%;
    background: #fff;
    .body-content {
      padding: 15px 20px 15px 20px;
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .content_one{
        height: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .blank-border {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    .bottom-button {
      float: right;
      margin-left: 20px;
    }
  }
}

.addbutton {
  border: 1px #009de5 solid;
  color: #009de5;
  float: right;
  margin: 10px;
  z-index: 100;
}

/deep/ .ant-upload-list {
  display: none;
}

.uploadfilelist {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  zoom: 1;

  .fileico {
    margin: 10px;
  }
  .itemname {
  }
  .itemsta {
    float: right;
    margin-right: 30%;
  }
  .download {
    float: right;
    margin: 5px;
  }
  .del {
    float: right;
    margin: 5px;
  }
}
.uploadfilelist:hover {
  background: #f3fbff;
}

/deep/ .form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
}

/deep/ .ant-table-footer{
  display: flex !important;
}
</style>